export default __webpack_public_path__ + "static/media/greenL.0d7068ae.svg";